import * as React from 'react';
import { shallow } from 'enzyme';
import { iconToggleDriverFactory } from './IconToggle.driver';
import { IconToggle, IconToggleLabelPlacement } from '.';
import { LikeHeart as Heart } from '@wix/wix-ui-icons-common/on-stage';
import { createRendererWithUniDriver } from '../../test/utils';

const ICON = <Heart />;
const LABEL = 'Like';

describe('IconToggle', () => {
  const createDriver = createRendererWithUniDriver(iconToggleDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<IconToggle icon={ICON} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should render label', async () => {
    const { driver } = createDriver(<IconToggle icon={ICON} label={LABEL} />);
    expect(await driver.label.text()).toBe(LABEL);
  });

  it('should not render label when empty', async () => {
    const { driver } = createDriver(<IconToggle icon={ICON} label="" />);
    expect(await driver.label.exists()).toBe(false);
  });

  it('should render label at start', async () => {
    const { driver } = createDriver(
      <IconToggle
        icon={ICON}
        label={LABEL}
        labelPlacement={IconToggleLabelPlacement.START}
      />,
    );
    expect(await driver.label.placement()).toBe(IconToggleLabelPlacement.START);
  });

  it('by default should render label at end', async () => {
    const { driver } = createDriver(<IconToggle icon={ICON} label={LABEL} />);
    expect(await driver.label.placement()).toBe(IconToggleLabelPlacement.END);
  });

  it('should render icon', async () => {
    const { driver } = createDriver(<IconToggle icon={ICON} />);
    expect((await driver.icon.getNative()).innerHTML).toBe(
      shallow(ICON).html(),
    );
  });

  it('should call onChange with actual value', async () => {
    const onChangeSpy = jest.fn();
    const { driver } = createDriver(
      <IconToggle icon={<div />} onChange={onChangeSpy} />,
    );
    expect(onChangeSpy).not.toHaveBeenCalled();
    await driver.click();
    expect(onChangeSpy).toHaveBeenCalledWith(
      expect.objectContaining({ checked: true }),
    );
  });

  it('should be disabled', async () => {
    const { driver } = createDriver(<IconToggle icon={<div />} disabled />);
    expect(await driver.isDisabled()).toBe(true);
  });

  it('should be checked', async () => {
    const { driver } = createDriver(<IconToggle icon={<div />} checked />);
    expect(await driver.isChecked()).toBe(true);
  });
});
